import { mapGetters } from "vuex";
import TogglesForm from "@/components/forms/togglesForm";
import RecordViews from "@/mixins/RecordViews";
export default {
  name: "ResourceBlock_Settings",
  components: {
    TogglesForm
  },
  mixins: [RecordViews],
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
  },
  created() {
    this.handleSettingsUserChange();
  },
  computed: {
    //move to mixin
    ...mapGetters({
      user: "user/user"
    })
  },
  beforeMount() {
    this.setUpToggles();
  },
  methods: {
    setUpToggles() {
      this.toggles.forEach(aToggle => {
        if (this.settingsUser.hasOwnProperty(aToggle.property)) {
          aToggle.value = this.settingsUser[aToggle.property];
        }
      });
    },
    handleToggleChange(event) {
      //Maybe make top level
      let checkedId = event.target.id ? event.target.id : null;
      if (checkedId) {
        this.settingsUser[checkedId] = event.target.checked
          ? event.target.checked
          : false;
      }
      this.handleSettingsUserChange(this.settingsUser);
    },
    handleSettingsUserChange() {
      //can be a mixin
      //this.$emit("settings-user-changed", settings);
      const payload = {
        settingsUser: this.settingsUser,
        toolId: this.resource.toolId
      };
      this.$store.dispatch("tools/setSettingsUserForTool", payload);
    },
    handleUpdateUserData(userDataPayload) {
      debugger;
      this.$emit("update-user-data", userDataPayload);
    },
    getSessionObj(){
      let filteredSession = this.settingsUser && this.settingsUser.sessions && Array.isArray( this.settingsUser.sessions) && this.sessionId ?
          this.settingsUser.sessions.filter((aSessionName)=> {
            return aSessionName.sessionId == this.sessionId;
          }): null;
      return filteredSession && Array.isArray(filteredSession) && filteredSession.length > 0 ? filteredSession[0] : null;
    }
  },
  data() {
    return {
      sessionId: this.checkSession("sessions"),
      settingsUser: {},
      toggles: []
    };
  }
};
